export default "__VITE_ASSET__Dymo0D3h__"